<template>

    <el-dialog
        :title="null"
        :visible.sync="dialogVisible"
        :close-on-click-modal=false
        :close-on-press-escape=false
        :show-close=false
        append-to-body
        :destroy-on-close=true
        width="650px"
        custom-class="jt-dialog-hide-header">
        <div>
            <div slot="title"></div>
            <h5 class="tac font14px text-color-error mb10">{{title}}</h5>
            <p class="text-color-gray tac mb20 font12px" v-if="subTitle">{{subTitle}}</p>
            <div class="content-wrap break-word" style="max-height: 400px;overflow-y: auto;">
                <div class="mb20 " v-for="(item,index) in errList" :key="'err-'+index">
                    <h4>任务：{{item.task_name}}（{{item.task_number}}）</h4>
                    <div class="mb10" v-for="(file,fileIndex) in item.detail||[]" :key="index+'file-err-'+fileIndex">
                        <p class="pl20 font12px">文件：{{file.daily_file_name}}
                            <span v-if="(file.deny_condition&&file.deny_condition.length>0)||(file.deny_dimension&&file.deny_dimension.length>0)||(file.deny_field&&file.deny_field.length>0)">(模板:{{file.template_name}}({{file.template_id}}))</span>
                        </p>
                        <div class="pl40 font12px" v-if="file.deny_account&&file.deny_account.length>0">账户：{{file.deny_account}}</div>
                        <div class="pl40 font12px" v-if="file.deny_company&&file.deny_company.length>0">客户：{{file.deny_company}}</div>
                        <div class="pl40 font12px" v-if="file.deny_app&&file.deny_app.length>0">产品：{{file.deny_app}}</div>
                        <div class="pl40 font12px" v-if="file.deny_condition&&file.deny_condition.length>0">筛选：{{file.deny_condition}}</div>
                        <div class="pl40 font12px" v-if="file.deny_dimension&&file.deny_dimension.length>0">维度：{{file.deny_dimension}}</div>
                        <div class="pl40 font12px" v-if="file.deny_field&&file.deny_field.length>0">指标：{{file.deny_field}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="footer" class="tac">
            <template v-if="isConfirm">
                <el-button @click="hideModal">取 消</el-button>
                <el-button type="primary" :loading="okLoading" @click="handleOk">继续生成</el-button>
            </template>
            <template v-else>
                <el-button type="primary" @click="hideModal">关闭</el-button>
            </template>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "ErrorTipModal",
        props:{},
        data(){
            return {
                dialogVisible:false,
                title:'',
                subTitle:'',
                errList:[],
                type:'',        // 标记
                isConfirm:false,
                okLoading:false,
            };
        },
        methods:{
            showModal(data){
                let actionData = data||{};
                this.title = actionData.title||'';
                this.subTitle = actionData.subTitle||'';
                this.errList = actionData.errList||[];
                this.actionType = actionData.actionType;
                this.actionData = actionData.actionData;
                this.isConfirm = !!actionData.isConfirm||false;
                this.okLoading = false;
                this.dialogVisible = true;
            },
            hideModal(){
                this.title = '';
                this.subTitle = '';
                this.errList = '';
                this.actionType = '';
                this.actionData = null;
                this.isConfirm = false;
                this.dialogVisible = false;
                this.okLoading = false;
                this.$emit('cancel',this.type);
            },
            handleOk(){
                this.okLoading  = true;
                this.$emit('ok',this.actionType,this.actionData);
            },
            setOkLoading(val){
                this.okLoading = !!val;
            }
        },
    }
</script>

<style scoped>

</style>
